import setAuthorizationToken from "../utils/setAuthorizationToken";
import {
  SET_CURRENT_USER,
  LOADING,
  GET_ERRORS,
  GET_USERS,
  GET_USER_BY_ID,
  SUCCESS_MESSAGE,
  RESET_PWD_SUCCESS,
  NOT_ACTIVE,
  INITIAL_LOAD
} from "./types";
import api from "../api";
import decode from "jwt-decode";

import store from "../index";
import { mqttConnectionInit } from "../actions/mqttAction";

export const setCurrentUser = decoded => ({
  type: SET_CURRENT_USER,
  payload: decoded
});

export const isInitialLoad = dispatch => ({
  type: INITIAL_LOAD,
  payload: true
});


// Login - Get user token
export const login = userData => dispatch => {
  localStorage.jwtToken = ''
  dispatch(setLoading());
  api.auth
    .login(userData)
    .then(authResponse => {
      const accessToken = authResponse.accessToken;
      localStorage.jwtToken = accessToken;
      // Set token to Auth header
      setAuthorizationToken(accessToken);
      // Decode token to get user data
      const decoded = decode(accessToken);
      localStorage.orgID = decoded.orgId;
      localStorage.branch = decoded.branch[0];
      dispatch(setCurrentUser(decoded));
    })
    .catch(err => {
      console.log(err.response.data);
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      });
    });
};

// Set loading state
export const setLoading = () => {
  return {
    type: LOADING
  };
};

// Log user out
export const logoutUser = () => dispatch => {
  // Remove token from localStorage
  localStorage.removeItem("jwtToken");
  localStorage.removeItem("orgID");
  localStorage.removeItem("branch");
  // Remove auth header for future requests
  setAuthorizationToken(false);
  window.location.reload(false);
  // Set current user to {} which will set isAuthenticated to false
  dispatch(setCurrentUser({}));
};

export const getUsers = () => dispatch => {

  let orgID;
  localStorage.orgID ? orgID = localStorage.orgID : orgID = 1;


  dispatch(setLoading());
  api.auth
    .getUsers(
      orgID
    )
    .then(users => {
      dispatch({
        type: GET_USERS,
        payload: users
      });
    });
};

export const getUser = id => dispatch => {
  dispatch(setLoading());
  let orgID;
  localStorage.orgID ? orgID = localStorage.orgID : orgID = 1;

  dispatch(setLoading());
  api.auth.getUsers(orgID).then(users => {
    let user = users.find(x => x.id === id);
    dispatch({
      type: GET_USER_BY_ID,
      payload: user
    });
  });
};

export const changePassword = (data, history) => dispatch => {
  api.auth
    .changePassword(data)
    .then(() => {
      //logoutUser();
      localStorage.removeItem("jwtToken");
      // localStorage.removeItem('orgID');
      // localStorage.removeItem('branch');
      // // Remove auth header for future requests
      setAuthorizationToken(false);
      window.location.reload(false);
      // // Set current user to {} which will set isAuthenticated to false
      // dispatch(setCurrentUser({}));
      dispatch({
        type: SUCCESS_MESSAGE
      });
      history.push("/");
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      });
    });
};

export const isActive = history => dispatch => {
  dispatch({
    type: NOT_ACTIVE
  });
  history.push("/");
};

export const editUser = (data, history) => dispatch => {
  api.auth.editUser(data).then(() => {
    history.push("/dashboard2/user-management");
  });
};

export const createUser = (data, history) => dispatch => {
  api.auth.createUser(data).then(() => {
    history.push("/dashboard2/user-management");
  });
};


export const forgotPassword = (userData, history) => dispatch => {
  dispatch(setLoading());
  api.auth
    .forgotPassword(userData)
    .then(() => {

      alert('Reset Link Sent to ' + userData.userEmail)
      window.location = "/";
    })
    .catch(err => {
      let message = "UPR-1000 : Internal Server Error";
      if (err.response) {
        message = err.response.data.message
      }
      dispatch({
        type: GET_ERRORS,
        payload: message
      });
    });
};


export const resetPassword = (data, token) => dispatch => {
  api.auth
    .resetPassword(data, token)
    .then(() => {
      //logoutUser();
      localStorage.removeItem("jwtToken");
      alert('Password Successfully Updated!')
      window.location = "/";
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      });
    });
};

export const adminResetPassword = (data) => dispatch => {
  // dispatch(setLoading());
  // Set token to Auth header
  setAuthorizationToken(localStorage.jwtToken);
  api.auth
    .adminResetPassword(data)
    .then((res) => {
      // dispatch({
      //   type: RESET_PWD_SUCCESS,
      //   payload: res
      // });
      alert(res)
    })
    .catch(err => {
      console.log('err :>> ', err);
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      });
    });
};
